import { BaseSysCalls } from './BaseSysCalls';
import { Lightning, Log } from '@lightningjs/sdk';

export class EOSSysCalls extends BaseSysCalls {
  static override exitApp(element: Lightning.Component) {
    if (element) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      element.application.closeApp();
    } else Log.error('no element passed to exitApp');
  }

  static override platformVersion() {
    return 'unknown';
  }

  static override modelName() {
    return 'Telenet EOS box';
  }
}
